module.exports = __webpack_public_path__ + "static/media/basel-6.81149ca5.jpg";